// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require select2
//= require search/_namespace
//= require_tree ./templates
//= require ./base
//= require ./user_search
//= require_tree .
// MAGIC_DESPROCKET_START
require('javascripts/select2/index.js')
require('sprocket-compat?this!javascripts/search/_namespace.coffee')
require('javascripts/search/templates/coauthor_search_cant_find_JST.wjs.js')
require('javascripts/search/templates/create_department_JST.wjs.js')
require('javascripts/search/templates/research_interest_result_JST.wjs.js')
require('javascripts/search/templates/user_result_JST.wjs.js')
require('sprocket-compat?this!javascripts/search/base.coffee')
require('sprocket-compat?this!javascripts/search/user_search.coffee')
require('sprocket-compat?this!javascripts/search/coauthor_search.coffee')
require('sprocket-compat?this!javascripts/search/create_department.coffee')
require('sprocket-compat?this!javascripts/search/department_search.coffee')
require('sprocket-compat?this!javascripts/search/research_interest_search.coffee')
require('sprocket-compat?this!javascripts/search/university_search.coffee')
// MAGIC_DESPROCKET_END
